import { RelayEnvironmentProvider } from 'react-relay'
import GlobalErrorBoundary from 'shared/components/ErrorBoundary/Global'
import relayService from 'shared/utils/relay'
import type { PropsWithChildren } from 'react'

const MobileWrapper = ({ children }: PropsWithChildren) => (
  <RelayEnvironmentProvider environment={relayService.environment}>
    <GlobalErrorBoundary>{children}</GlobalErrorBoundary>
  </RelayEnvironmentProvider>
)

export default MobileWrapper
